import { queryOptions } from '@tanstack/react-query';

import { fetchBackend } from '@/lib/queries/apiClient';

export type PagerDutyIncident = {
  id: string;
  incidentId: string;
  createdAt: string;
  updatedAt: string;
  projectId: string;

  pagerDutyId: string;
  title: string;
  summary: string;
  incidentNumber: number;
  status: string;
  startedAt: string;
  resolvedAt?: string;
  priority?: string;
  url?: string; // URL to the PagerDuty incident
};

export type SlackIncident = {
  id: string;
  incidentId: string;
  createdAt: string;
  updatedAt: string;
  projectId: string;

  userId: string;
  messageText: string;
  workspaceId: string;
  workspaceName: string;
  channelId: string;
  channelName: string;
  threadTs: string;
  status: string; // TODO - Enum
  extractedPagerDutyId?: string;
  url?: string; // URL to the Slack message or channel
};

export type IncidentSource = 'pagerduty' | 'slack';

export type Incident = {
  id: string;
  createdAt: string;
  updatedAt: string;
  projectId: string;
  pagerDutyIncident?: PagerDutyIncident;
  slackIncident?: SlackIncident;
  sources: IncidentSource[];
};

export const incidentsManagementPagerDutyIncidentsQueries = {
  all: () => ['incidents-management', 'pagerduty-incidents'],
  byProject: (projectId: string) => [
    ...incidentsManagementPagerDutyIncidentsQueries.all(),
    projectId,
  ],
  list: (projectId: string, interval?: number) =>
    queryOptions({
      queryKey: [
        ...incidentsManagementPagerDutyIncidentsQueries.byProject(projectId),
        'list',
      ],
      queryFn: async () => {
        const incidents = await listIncidents(projectId);

        return incidents.map(incident => ({
          ...incident,
          sources: [
            ...(incident.pagerDutyIncident ? ['pagerduty'] : []),
            ...(incident.slackIncident ? ['slack'] : []),
          ],
        })) as Incident[];
      },
      ...(interval === undefined
        ? {}
        : { refetchInterval: interval, refetchIntervalInBackground: true }),
    }),
} as const;

const listIncidents = async (projectId: string): Promise<Incident[]> => {
  const getResponse = await fetchBackend(`/rca/${projectId}/incidents`, {
    method: 'GET',
  });

  if (!getResponse.ok) {
    throw new Error(`Error: ${getResponse.statusText}`);
  }

  const data = (await getResponse.json()) as {
    incidents: Incident[];
  };

  return data.incidents.map(incident => ({
    ...incident,
    sources: [
      ...(incident.pagerDutyIncident ? ['pagerduty'] : []),
      ...(incident.slackIncident ? ['slack'] : []),
      // ...(incident.incidentIoIncident ? ['incidentio'] : []),
    ],
  })) as Incident[];
};

// export type IncidentIoIncident = {
//   incidentId: string;
//   createdAt: string;
//   updatedAt: string;
//   projectId: string;
//   id: string;
//   title: string;
//   summary: string;
//   incidentNumber: number;
//   status: string;
//   severity?: string; // SEV-0, SEV-1, SEV-2, etc.
//   startedAt: string;
//   resolvedAt?: string;
// };
